import MuiDatePicker from "../../../utils/MuiFields/DatePicker";

import useReportStore from "../../../store/reports";

const DatePicker = ({ field, type = "start"}) => {

  let selector = type === "start" ? "$gte" : "$lte";

  const reportType = useReportStore(state => state.reportType);
  const filters = useReportStore(state => state.filters);
  let dateObj = filters[reportType]?.[field] || {};
  const handleFilter = useReportStore(state => state.handleFilter);

  const changeHandler = (e, queryType) => handleFilter(e, reportType, field, queryType, "date");

  return (
    <MuiDatePicker 
      style={{bgcolor: '#f8f8f8'}}
      value={dateObj[selector] || null} 
      onChange={(e) => changeHandler(e, selector)} 
    />
  )
};

export default DatePicker;